export const DEFAULT_DATE_FORMAT = 'MM/DD/YY';

export const API_DATE_FORMAT = 'YYYY-MM-DD';
